import React from "react";
import LayersSvg from "./layers-svg";
import styles from "./map-buttons.module.scss";
import PropTypes from "prop-types";

const LayersButton = ({ onClick }) => {
    return (
        <button
            className={`${styles.headerButton} ${styles.layersButton}`}
            onClick={() => {
                onClick();
            }}
            aria-label={`Toggle base map`}
            tabIndex={1}
        >
            <LayersSvg />
        </button>
    );
};

LayersButton.propTypes = {
    onClick: PropTypes.func.isRequired,
};

export default LayersButton;



// WEBPACK FOOTER //
// ./src/components/ui/map-buttons/LayersButton.js